




































































import { Vue, Component } from 'vue-property-decorator';

@Component({
    props: ['invitations', 'ownerUuid']
})
export default class InvitationsList extends Vue {
    discardInvitation(invitedEmail: string) {
        this.$emit('discard-invitation', this.$props.ownerUuid, invitedEmail);
    }
}
